import {size} from 'lodash/fp';
import React from 'react';
import PropTypes from 'prop-types'

import mainConfig from '../../../config/main.js';
import googleMapsHelper from '../../../utils/googleMapsHelper.js';

/**
 * The TicketViewMap component.
 *
 * @constructor
 */
export class TicketViewMap extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const locationData = this.props.location || {};

    const apiKey = mainConfig.google.staticMaps.apiKey || null;
    let fullAddress = null;
    let mapParams = null;

    if (apiKey && locationData && size(locationData)) {
      fullAddress = googleMapsHelper.parseAddress(locationData);
      mapParams = googleMapsHelper.parseMapParameters(locationData, apiKey);
    }

    return (
      <div className="ticket-view-map">
        {(mapParams && fullAddress) && (
          <div className="wgl-line-item wgl-line-item--map map-item">
            <a href={`https://maps.google.com/?q=${fullAddress}`} className="wgl-map-link" target="_blank">
              <img
                className="wgl-map-img"
                src={`https://maps.googleapis.com/maps/api/staticmap?${mapParams}`}
                alt="Location Map"
              />
            </a>
          </div>
        )}
      </div>
    );
  }
}

TicketViewMap.propTypes = {
  location: PropTypes.shape({
    address: PropTypes.string,
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string
  }).isRequired
};

export default TicketViewMap;



// WEBPACK FOOTER //
// ./src/components/ticket/ticketViewMap/TicketViewMap.js